import { render } from "./AgendaEdu.vue?vue&type=template&id=78ca1a87"
import script from "./AgendaEdu.vue?vue&type=script&lang=js"
export * from "./AgendaEdu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__